import { GET_LANGS_SUCCESS } from './constants';

/**
 *
 * @param state
 * @param action
 * @returns {(function(*=, *): (*))|{}}
 */
const langsReducer = ( state = {}, action ) => {
    switch ( action.type ) {
        case GET_LANGS_SUCCESS:
            return action.langs;
        default:
            return state;
    }
};

export default langsReducer;